import { AnnotationPlugin } from '@st/document-viewer-kit'
import { TextAnnotation } from '@st/sdk/src/sdk.types'
import { TextToolState } from '~/st-doc-viewer/annotations'
import { TextAnnotationElement, TextToolOverlay } from './ui'
import { copyToolState, TEXT_COLOR_OPTIONS } from './tool-state'

export { TextToolEditor } from './ui'

export function textToolPlugin(): AnnotationPlugin<TextAnnotation, TextToolState> {
  return {
    name: 'text',
    initialToolState: {
      name: 'text',
      settings: {
        color: TEXT_COLOR_OPTIONS[0],
        font: { family: 'Helvetica', size: 24, weight: 'normal' }
      }
    },
    ToolOverlay: TextToolOverlay,
    Element: TextAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'text',
    onAnnotationSelected: (event) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        return { type: 'updateTool', tool: copyToolState(annotation) }
      }
      return null
    },
    onAnnotationDeselected: (event) => {
      if (event.annotationDraft && event.annotationDraft.content == '') {
        if (event.annotation) {
          // we need to delete it since it exists on the server
          return { type: 'deleteAnnotation', annotationId: event.annotation.id }
        } else {
          // we just need to discard the draft since it doesn't exist on the server
          return { type: 'discardAnnotationDraft', annotationId: event.annotationDraft.id }
        }
      }

      if (event.annotationDraft)
        return { type: 'commitAnnotationDraft', annotationDraft: event.annotationDraft }
      return null
    }
  }
}
